/* eslint-disable ember/classic-decorator-hooks, ember/no-classic-components, ember/no-computed-properties-in-native-classes */
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { tagName } from '@ember-decorators/component';
import { TYPES } from 'linced-app/utils/progress-overview';

/**
 * Insights::FloatingControls holds the progress overview's page-wide
 * settings: how every chart reads the year, and which year the single-year
 * charts show. It can be minimised to a small summary for schools that set it
 * once, which is saved to the person's options like the settings themselves.
 *
 * @param {string} mode - HALVES or TYPES.
 * @param {Function} onModeChange
 * @param {Array<Object>} yearOptions
 * @param {string} selectedYear
 * @param {Function} onYearChange
 */
@tagName('')
export default class FloatingControls extends Component {
  @service
  personOptions;

  /**
   * @type {boolean} Starts as the person last left it, except on screens
   * narrower than 960px (where the bottom navigation shows), where it starts
   * minimised so it doesn't cover the charts.
   */
  @tracked minimised = false;

  init() {
    super.init(...arguments);
    this.minimised =
      this.personOptions.progressOverview.controlsMinimised ||
      window.matchMedia('(max-width: 959px)').matches;
  }

  @computed('mode')
  get modeLabel() {
    return this.mode === TYPES ? 'Interim / full' : 'First / second half';
  }

  // Changes at once and saves in the background, as the mode and year do.
  _setMinimised(minimised) {
    this.minimised = minimised;
    this.personOptions.setProgressOverview({ controlsMinimised: minimised });
  }

  @action
  minimise() {
    this._setMinimised(true);
  }

  @action
  expand() {
    this._setMinimised(false);
  }
}
